import React, { useEffect, useState } from 'react';

export default function CircularProgressBar({ value, size, strokeWidth }) {
    const [currentValue, setCurrentValue] = useState(value);

    useEffect(() => {
        if (currentValue !== value) {
            const animationDuration = 35; // Duration in ms
            const steps = Math.abs(currentValue - value);
            const stepDuration = animationDuration / steps;
            console.log(steps)

            let stepCount = 0;
            const step = () => {
                setCurrentValue(prev => {
                    if (prev === value) {console.log(prev); return prev;}
                    console.log(prev < value ? prev + 1 : prev - 1)
                    return prev < value ? prev + 1 : prev - 1;
                });
                stepCount += 1;
                if (stepCount < steps) {
                    setTimeout(step, stepDuration);
                }
            };

            step();
        }
    }, [value]);

    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (value / 100) * circumference;

    const angle = (currentValue / 100) * 360;
    const radians = (angle - 90) * (Math.PI / 180);
    const capX = (size / 2) + radius * Math.cos(radians);
    const capY = (size / 2) + radius * Math.sin(radians);

    return (
        <svg width={size} height={size} className="circular-progress-bar">
            <circle
                className="circular-progress-bar__background"
                stroke="#F2F3F7"
                strokeWidth={strokeWidth}
                fill="none"
                cx={size / 2}
                cy={size / 2}
                r={radius}
            />
            <circle
                className="circular-progress-bar__progress"
                stroke="#2F6FBE"
                strokeWidth={strokeWidth}
                fill="none"
                cx={size / 2}
                cy={size / 2}
                r={radius}
                strokeDasharray={circumference}
                strokeDashoffset={offset}
                strokeLinecap="round"
            />
            <circle
                className="circular-progress-bar__cap"
                fill="#ffffff"
                cx={capX}
                cy={capY}
                r={(strokeWidth / 2) - 1}
                stroke="#2F6FBE"
                strokeWidth={2}
            />
            <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dy=".3em"
                fontSize="20px"
                fontWeight="600"
                fill="#2F6FBE"
            >
                {`${value}%`}
            </text>
        </svg>
    );
};